import { useNavigate } from 'react-router-dom';
import { Chip, DropdownMenuItem } from '@c2fo/liquidity';
import { EyeIcon } from '@c2fo/liquidity/icons';
import type { DeliveriesSortField } from '../../contexts/FileDeliveryContext';
import { TableHeader } from '../TableHeader';
import { DataTable, DataTableHead, DataTableBody, DataTableRow, DataTableCell } from '../DataTable';
import { ActionsMenu } from '../ActionsMenu';
import { useDeliveriesState } from '../../contexts';
import { getStateChipType, getStateLabel } from '../../utils';

export const DeliveryTable: React.FC = () => {
  const navigate = useNavigate();
  const { deliveries, sortField, sortDirection, setSort } = useDeliveriesState();

  const handleSort = (field: DeliveriesSortField) => {
    if (sortField === field) {
      const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      setSort(field, newDirection);
    } else {
      setSort(field, 'desc');
    }
  };

  return (
    <DataTable>
      <DataTableHead>
        <TableHeader label="Type" align="center" className="w-24" />
        <TableHeader label="Target" />
        <TableHeader
          field="state"
          label="Status"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
        />
        <TableHeader
          field="end_time"
          label="Time"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
          className="w-40"
        />
        <TableHeader label="" className="w-16" />
      </DataTableHead>
      <DataTableBody>
        {deliveries.map((delivery) => (
          <DataTableRow key={delivery.name}>
            <DataTableCell align="center">
              <Chip
                label={delivery.scheduledDelivery ? 'Scheduled' : 'Immediate'}
                type="secondary"
                variant="outlined"
                size="xs"
              />
            </DataTableCell>
            <DataTableCell variant="secondary">
              <span className="text-gray-700 font-medium text-xs">{delivery.targetLocation ?? 'Unknown'}</span>
            </DataTableCell>
            <DataTableCell>
              <div className="flex items-center gap-2">
                <Chip
                  label={getStateLabel(delivery.state)}
                  type={getStateChipType(delivery.state)}
                  variant="filled"
                  size="xs"
                />
                {delivery.statusMessage && <span className="text-sm text-gray-500">{delivery.statusMessage}</span>}
              </div>
            </DataTableCell>
            <DataTableCell variant="date">
              {delivery.endTime ? new Date(delivery.endTime).toLocaleString() : '-'}
            </DataTableCell>
            <DataTableCell align="center">
              <ActionsMenu>
                <DropdownMenuItem
                  className="active:bg-lightBlue-100"
                  onSelect={() => navigate(`/file-delivery/${delivery.name}`)}
                >
                  <EyeIcon className="h-4 w-4 mr-2" />
                  View Details
                </DropdownMenuItem>
              </ActionsMenu>
            </DataTableCell>
          </DataTableRow>
        ))}
      </DataTableBody>
    </DataTable>
  );
};
